import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import {
  SectionCard,
  SectionHeader,
  SectionTitle,
  ViewAllButton,
  CloseButton,
  StyledCollapse,
  TableContainer,
} from './styles';
import { DASHBOARD_ROUTES, BUTTON_LABELS } from './constants';
import { CustomizationsSectionProps } from './types';

const { Panel } = StyledCollapse;

const CustomizationsSection: React.FC<CustomizationsSectionProps> = ({
  isOpen,
  onClose,
  isLoading = false,
  customizationsData = [],
}) => {
  const navigate = useNavigate();

  const handleViewAll = () => {
    if (!isLoading) {
      navigate(DASHBOARD_ROUTES.CUSTOMIZATIONS);
    }
  };

  // Get top 5 customizations
  const topCustomizations = customizationsData.slice(0, 5);

  const columns: ColumnsType<any> = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text) => <span>{text || '-'}</span>,
    },
    {
      title: 'Options',
      dataIndex: 'options',
      key: 'options',
      render: (options) => {
        const count = Array.isArray(options) ? options.length : 0;
        return <span>{count}</span>;
      },
    },
  ];

  return (
    <StyledCollapse
      activeKey={isOpen ? ['customizations'] : []}
      ghost
      expandIcon={() => null}
    >
      <Panel key="customizations" header={null}>
        <SectionCard>
          <SectionHeader>
            <SectionTitle level={4}>Customizations</SectionTitle>
            <CloseButton
              type="text"
              icon={<CloseOutlined />}
              onClick={onClose}
              aria-label="Close"
            />
          </SectionHeader>

          {topCustomizations.length > 0 ? (
            <TableContainer>
              <Table
                columns={columns}
                dataSource={topCustomizations.map((customization) => ({
                  ...customization,
                  key: customization.id,
                }))}
                pagination={false}
                loading={isLoading}
                size="small"
                bordered={false}
              />
            </TableContainer>
          ) : (
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <p>No customizations found</p>
            </div>
          )}

          <div style={{ marginTop: '16px', display: 'flex', justifyContent: 'flex-end' }}>
            <ViewAllButton type="primary" onClick={handleViewAll} disabled={isLoading}>
              {BUTTON_LABELS.VIEW_ALL_CUSTOMIZATIONS}
            </ViewAllButton>
          </div>
        </SectionCard>
      </Panel>
    </StyledCollapse>
  );
};

export default CustomizationsSection;
